import type { FilesFormatSchemaWithId } from '@iconik-io/iconik-api/src/services/files';

export const isPdfFormat = (
  originalFormatMetadata: FilesFormatSchemaWithId['metadata'] | undefined,
) =>
  originalFormatMetadata?.[0]?.format === 'PDF' ||
  originalFormatMetadata?.[0]?.internet_media_type === 'application/pdf';
